module.exports = __webpack_public_path__ + "img/pantalla-9-7.63996faf.png";